import React from 'react';

// "Create your first page": a dashed page with a red and amber oval and a + badge.
export const FirstUseIllustration = () => (
    <svg width="168" height="84" viewBox="0 0 168 84" aria-hidden="true">
        <rect x="24" y="6" width="120" height="72" rx="10" fill="#F7F6F2" stroke="#D9D6CC" strokeWidth="1.5" strokeDasharray="5 5"/>
        <ellipse cx="62" cy="32" rx="22" ry="10" fill="#FDECEC" stroke="#E5484D" strokeWidth="2"/>
        <ellipse cx="106" cy="52" rx="22" ry="10" fill="#FEF4DE" stroke="#F5A524" strokeWidth="2"/>
        <circle cx="144" cy="12" r="12" fill="#141416"/>
        <path d="M144 7v10M139 12h10" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"/>
    </svg>
);

// "No pages match…": a search icon inside an outlined oval.
export const NoResultsIllustration = () => (
    <div style={{
        width: 72, height: 48, borderRadius: '50%', border: '2px solid #D9D6CC',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#45444B" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <circle cx="11" cy="11" r="7"/>
            <path d="M20 20l-3.5-3.5"/>
        </svg>
    </div>
);

// "No tasks yet": a dashed oval inside a dashed box, for the editor's Tasks panel.
export const PanelEmptyIllustration = () => (
    <svg width="44" height="28" viewBox="0 0 44 28" aria-hidden="true">
        <ellipse cx="22" cy="14" rx="19" ry="11" fill="none" stroke="#8A887F" strokeWidth="2" strokeDasharray="5 4"/>
    </svg>
);

// "We couldn't load…": an "!" inside a red-tint oval.
export const ErrorIllustration = () => (
    <div style={{
        width: 72, height: 48, borderRadius: '50%', background: '#FDECEC', border: '2px solid #E5484D',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B42318" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <path d="M12 7v6M12 17h.01"/>
        </svg>
    </div>
);
